<script setup>
import { computed } from 'vue';
import { useMessageContext } from './provider.js';
import { hasOneDayPassed } from 'shared/helpers/timeHelper';
import { MESSAGE_STATUS } from './constants';

defineProps({
  error: { type: String, required: true },
});

const emit = defineEmits(['retry']);

const { status, createdAt } = useMessageContext();
const canRetry = computed(() => !hasOneDayPassed(createdAt.value));
</script>

<template>
  <div class="sz-failed-msg-not-sent">
    <button
      v-if="canRetry"
      type="button"
      :disabled="status !== MESSAGE_STATUS.FAILED"
      class="sz-failed-retry"
      :title="error || 'Falha no envio'"
      @click="emit('retry')"
    >
      Mensagem não enviada
    </button>
    <span v-else class="sz-failed-label">Mensagem não enviada</span>
  </div>
</template>

<style>
.sz-failed-msg-not-sent {
  font-family: 'Inter', system-ui, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #6B2A2A;
  display: flex;
  justify-content: flex-end;
  padding-right: 40px;
  margin-top: 2px;
}
.sz-failed-retry,
.sz-failed-label {
  background: transparent;
  border: 0;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}
.sz-failed-retry:hover {
  text-decoration: underline;
}
.sz-failed-retry:disabled {
  cursor: default;
  text-decoration: none;
}
.dark .sz-failed-msg-not-sent {
  color: #EB9696;
}
</style>
